import { Component, OnInit, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material';
import { Router } from '@angular/router';

@Component({
  selector: 'app-toolbar-header',
  templateUrl: './toolbar-header.component.html',
  styleUrls: ['./toolbar-header.component.css']
})
export class ToolbarHeaderComponent implements OnInit {

  @ViewChild('menuTrigger') trigger: MatMenuTrigger;

  constructor(private router: Router) { }

  ngOnInit() {
  }

  onOpenMenu($event){
    this.trigger.openMenu();
  }

  closeMenu(){
    this.trigger.closeMenu();
  }
  navigateTo(link)
  {
    this.router.navigate([link]);
  }
}



// WEBPACK FOOTER //
// ./src/app/toolbar-header/toolbar-header.component.ts